import { HttpEvent, HttpHandler, HttpInterceptor, HttpParams, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable, Optional } from '@angular/core';
import { map, Observable } from 'rxjs';
import { JsonParser } from '../../services/json/json-parser.service';

/**
 * HTTP-Interceptor um ein custom {@link JsonParser} Service zur Serialisierung und Deserialisierung von Daten über den HttpClient anzuwenden.
 */
@Injectable()
export class CustomJsonParserHttpInterceptor implements HttpInterceptor {
    constructor(@Optional() private customJsonParser: JsonParser) {}

    public intercept(httpRequest: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (httpRequest.responseType === 'json') {
            // If the expected response type is JSON then handle it here.
            return this.handleWithJsonResponse(httpRequest, next);
        } else {
            return next.handle(httpRequest);
        }
    }

    private handleWithJsonResponse(httpRequest: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        // Apply custom stringification.
        let body = httpRequest.body;
        let setHeaders = {};
        if (
            body !== null &&
            !(body instanceof ArrayBuffer) &&
            !(body instanceof Blob) &&
            !(body instanceof FormData) &&
            !(body instanceof URLSearchParams) &&
            !(body instanceof HttpParams) &&
            (typeof body === 'object' || typeof body === 'boolean' || Array.isArray(body))
        ) {
            body = this.json.stringify(body);
            setHeaders = { 'Content-Type': 'application/json' };
        }

        // Override the responseType to disable the default JSON parsing.
        httpRequest = httpRequest.clone({ responseType: 'text', body, setHeaders });
        // Handle the response using the custom parser.
        return next.handle(httpRequest).pipe(map((event) => this.parseJsonResponse(event)));
    }

    private parseJsonResponse(event: HttpEvent<unknown>): HttpEvent<unknown> {
        if (event instanceof HttpResponse && event.body && typeof event.body === 'string') {
            return event.clone({ body: this.json.parse(event.body) });
        } else {
            return event;
        }
    }

    private get json(): JsonParser | JSON {
        return this.customJsonParser || JSON;
    }
}
